import { createStore, createEvent, createEffect } from 'effector';
import { TELEGRAM_CONFIG } from '../config/telegramConfig';

// Типы для состояний MainButton
export type SecondaryButtonState = 'initial' | 'hidden' | 'terms' | 'terms_inactive' | 'scan' | 'scan_inactive' | 'get_reward' | 'waiting_reward';

// События
export const setSecondaryButtonState = createEvent<SecondaryButtonState>();
export const setSecondaryButtonText = createEvent<string>();
export const setSecondaryButtonAction = createEvent<() => void>();
export const setSecondaryButton = createEvent<SecondaryButtonStore>();

// Глобальная переменная для хранения текущего действия
let currentAction: (() => void) | null = null;
let currentState: SecondaryButtonState = 'hidden';
let hasGlobalHandler = false;

// Эффект для обновления MainButton
export const updateSecondaryButtonFx = createEffect<{
  state: SecondaryButtonState;
  text: string;
  action: () => void;
}, void>(({ state, text, action }) => {
  const telegramWebApp = window.Telegram?.WebApp;
  if (!telegramWebApp?.SecondaryButton) return;

  console.log(`Updating SecondaryButton: state=${state}, text=${text}, action=${action.name || 'anonymous'}`);

  // Сохраняем текущее состояние и действие
  currentState = state;
  currentAction = action;

  if (state === 'hidden') {
    telegramWebApp.SecondaryButton.hide();
    return;
  }

  // Устанавливаем текст
  telegramWebApp.SecondaryButton.setText(text);
  
  // Устанавливаем цвет в зависимости от состояния
  if (state.includes('inactive')) {
    telegramWebApp.SecondaryButton.color = '#757575'; // Серый цвет для неактивной кнопки
    telegramWebApp.SecondaryButton.disable();
  } else {
    telegramWebApp.SecondaryButton.textColor = telegramWebApp.MainButton.textColor;
    telegramWebApp.SecondaryButton.color = TELEGRAM_CONFIG.mainButtonColor; // Синий цвет для активной кнопки
    telegramWebApp.SecondaryButton.enable();
  }
  
  // Устанавливаем глобальный обработчик только один раз
  if (!hasGlobalHandler) {
    telegramWebApp.SecondaryButton.onClick(() => {
      console.log(`SecondaryButton clicked: state=${currentState}, text=${text}, action=${currentAction?.name || 'anonymous'}`);
      if (currentAction) {
        currentAction();
      }
    });
    hasGlobalHandler = true;
  }
  
  telegramWebApp.SecondaryButton.show();
});

export type SecondaryButtonStore = {
  state: SecondaryButtonState;
  text: string;
  action: (() => void) | null;
};
// Store
export const secondaryButtonStore = createStore<SecondaryButtonStore>({
  state: 'hidden',
  text: '',
  action: null,
})
  .on(setSecondaryButtonState, (state, newState) => ({ ...state, state: newState }))
  .on(setSecondaryButtonText, (state, text) => ({ ...state, text }))
  .on(setSecondaryButtonAction, (state, action) => ({ ...state, action }))
  .on(setSecondaryButton, (state, newState) => ({ ...state, ...newState }));

// Обновляем SecondaryButton при изменении store
secondaryButtonStore.watch(({ state, text, action }) => {
  if (state === 'hidden' || !action) {
    const telegramWebApp = window.Telegram?.WebApp;
    telegramWebApp?.SecondaryButton?.hide();
    return;
  }

  updateSecondaryButtonFx({ state, text, action });
});
